import { Component, OnInit, OnDestroy } from '@angular/core';
import { EmailFeedService } from 'src/app/services/integrations/email/email-feed.service';
import { EmailService } from 'src/app/services/integrations/email/email.service';
import { GeneralService } from 'src/app/services/general.service';
import { SignupLoginService } from 'src/app/services/signupLogin.service';
import { LeadService } from 'src/app/services/client-services/leads.service';
import { NoteModel } from 'src/app/models/note.model';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GeneralTaskService } from 'src/app/services/task/general-task.service';
import { NoteFeedService } from 'src/app/services/notes/notes-feeds.service';
import { LogFeedService } from 'src/app/services/log-activity/logs-feeds.service';

@Component({
  selector: 'app-all-feeds',
  templateUrl: './all-feeds.component.html',
  styleUrls: ['./all-feeds.component.css']
})
export class AllFeedsComponent implements OnInit, OnDestroy {

  private unsubscribe = new Subject<any>();

  isLoadingData: boolean = false;
  isContextRecieved: boolean = false;
  isSupervisor: boolean = false;
  connectedEmail: string = '';
  userEmail: string = '';
  userId: number;
  orgId: number;

  default_emails: Array<any> = [];
  emails: Array<any> = [];
  userNotes: Array<any> = [];
  activityLogs: Array<any> = [];
  currentIndex: number = 10;
  isLoadingMore: boolean = false;
  context_primary_email: string;
  context_context_name: string;
  filteredEmails: any[];
  constructor(
    private emailFeedService: EmailFeedService,
    private emailService: EmailService,
    private noteSrv: NoteFeedService,
    private logSrv: LogFeedService,
    private generalTaskSrv: GeneralTaskService,
    private generalService: GeneralService,
    private leadService: LeadService,
    private signUpService: SignupLoginService,
  ) {
    this.userId = this.emailService.user_id;
    this.orgId = this.emailService.org_id;
    const localstorage_user_data = JSON.parse(localStorage.getItem('currentUser'));
    this.isSupervisor = localstorage_user_data.supervisor;
    this.userEmail = this.generalService.user.email;
  }

  ngOnInit() {
    this.userNotes = [];
    this.activityLogs = [];
    this.emails = []; 
    this.filteredEmails = [];
    this.emailService.user_data.subscribe(data => {
      if (!Object.keys(data).length) return;
      this.connectedEmail = data.service_key || '';
    });

    this.getPageContext();

    this.emailService.new_email.subscribe(data => {
      if (!this.generalService.checkIfObjectIsEmpty(data)) {
        this.emailFeedService.handleNewMessage(data);
      }
    });

    this.emailFeedService.default_messages.subscribe(messages => {
      this.setEmails(messages);
    });

    this.emailService.email_context.subscribe((context: any) => {
      if (!this.generalService.checkIfObjectIsEmpty(context) && !this.isContextRecieved) {
        this.isContextRecieved = true;

        const context_data = this.emailFeedService.process_context_data(context);
        this.context_primary_email = context_data.context_primary_email
        this.context_context_name = context_data.context_name
        this.emailService.context_primary_email_address.next(context_data.context_primary_email);

        const email_list: Array<string> = [context_data.context_primary_email, ...context_data.context_email_list];

        let query_string = '', user_query_string = '', deal_query_string = '';
        switch (context_data.context_name) {
          case 'lead':
            query_string = `${context_data.context_primary_email}`;
            this.fetch_relevant_emails(query_string, user_query_string, deal_query_string);
            break;
          case 'contact':
            query_string = `${context_data.context_primary_email}`;
            this.fetch_relevant_emails(query_string, user_query_string, deal_query_string);
            break;
          case 'deal':
            query_string = `${email_list.join()}`;
            deal_query_string = `${context_data.context_entity_id}`;
            this.fetch_relevant_emails(query_string, user_query_string, deal_query_string);
            break;
          case 'salesperson':
            if (!this.isSupervisor && context_data.context_entity_id == this.userId.toString()) {
              query_string = `${context_data.context_primary_email}`;
              user_query_string = `${this.userId}`;
              this.fetch_relevant_emails(query_string, user_query_string, deal_query_string);
            } else if (this.isSupervisor) { // I am a suprvisor
              query_string = `${context_data.context_primary_email}`;

              if (context_data.context_entity_id == this.userId.toString()) { // I am the salesperson in context
                user_query_string = `${this.userId}`;
                this.fetch_relevant_emails(query_string, user_query_string, deal_query_string);
                break;
              }

              // I am not the salesperson in context
              this.signUpService.fetchSubordinates(this.userEmail).subscribe((response: any) => {
                for (let i in response) {
                  const subordinate = response[i];
                  if (context_data.context_primary_email == subordinate.email.toLowerCase()) {
                    user_query_string = `${subordinate.id}`;
                    this.fetch_relevant_emails(query_string, user_query_string, deal_query_string);
                    break;
                  }
                }
              }, err => {
                this.isLoadingData = false;
              });
            }

            break;
          case 'dashboard':
            query_string = `${context_data.context_primary_email},${(this.emailService.getUserData()).serviceKey || ''}`;
            user_query_string = `${this.userId}`;

            if (this.isSupervisor) {
              this.signUpService.fetchSubordinates(context_data.context_primary_email).subscribe((response: any) => {
                let sub_emails = response.map(subordinate => subordinate.email);
                let sub_ids = response.map(subordinate => subordinate.id);

                query_string = `${query_string},${sub_emails.join()}`;
                user_query_string = `${user_query_string},${sub_ids.join()}`;
                this.fetch_relevant_emails(query_string, user_query_string, deal_query_string);
              }, err => {
                this.isLoadingData = false
              });
            } else {
              this.fetch_relevant_emails(query_string, user_query_string, deal_query_string);
            }
            break;
          case 'company':
          case 'team':
            query_string = `${email_list.join()}`;
            this.fetch_relevant_emails(query_string, user_query_string, deal_query_string);
            break;
          default:
        }

      }
    });

  }

  check_if_thread_has_lead(index = 0) {
    if (this.default_emails.length <= index) return;

    const message = this.emails[index];
    const { recipient, cc_recipients, bcc_recipients } = message;
    const query_string = `email=${[recipient, ...cc_recipients, ...bcc_recipients].join()}`;
    this.leadService.filterLead(query_string).subscribe((response: any) => {
      if (response && response.success) {
        if (this.emails[index]) {
          this.emails[index].has_lead = !!response.payload.length;
        }
        this.check_if_thread_has_lead((index + 1));
      }
    });
  }

displayFeedItems() {
  if ((this.context_context_name === 'contact' || this.context_context_name === 'company' || this.context_context_name === 'lead')) {
    if (!this.context_primary_email) {
      return [];
    }

    this.filteredEmails = this.emails.filter(email => 
      email.metadata.from.address === this.context_primary_email || 
      email.metadata.to.some(recipient => recipient.address === this.context_primary_email)
    );
    
    let finalItems = [
      ...this.filteredEmails, 
      ...this.userNotes,
      ...this.activityLogs,
    ];
    
    finalItems.sort((a, b) => b.date - a.date);
    return finalItems.slice(0, this.currentIndex);
  }
  this.filteredEmails = this.emails;
  let all_items = [
    ...this.emails,
    ...this.userNotes,
    ...this.activityLogs,
  ];
  
  all_items.sort((a, b) => b.date - a.date);
  return all_items.slice(0, this.currentIndex);
}


  loadMoreItems() {
    this.isLoadingData = true;
    const batchSize = 10;
    const startIndex = this.currentIndex;
    this.currentIndex += batchSize; 
    setTimeout(() => {
      this.isLoadingData = false;
    }, 1000);
  }

  fetch_relevant_emails(general_query, user_query, deal_query, page = 0, population = 10) {
    const user_email = this.connectedEmail.toLocaleLowerCase();
    this.emailFeedService
      .fetch_emails(user_email, general_query, user_query, deal_query, page, population)
      .subscribe((response: any) => {
        this.isLoadingData = false;
        // this.setEmails(response);
      }, error => {
        this.isLoadingData = false;
      })
  }

  setEmails(emails) {
    this.default_emails = emails;
    if (this.context_context_name === 'contact' || this.context_context_name === 'company' || this.context_context_name === 'lead') {
      if (this.context_primary_email) {
        this.emails = emails;
      }
    } else {
      this.emails = emails;
    }
  }

  /**
   * Get All Note(s)
   */
  getPageContext() {
    this.emailService.email_context.subscribe((context: any) => {
      if (!this.generalService.checkIfObjectIsEmpty(context)) {
        this.getData(context);
      }
    });
  }

  getData(context) {
    this.userNotes = [];
    this.activityLogs = [];
    let pageNo = 0;
    pageNo += 1;
    switch (context.name) {

      case 'lead':
        this.noteSrv.notesFeeds(context.data.id, 4, pageNo)
          .subscribe((userNotes: any) => {
            this.userNotes = userNotes;
          })
        this.logSrv.logFeeds(context.data.id, 4, pageNo)
          .subscribe((activityLogs) => {
            this.activityLogs = activityLogs;
          })
        break;

      case 'dashboard':
        if (this.isSupervisor) {
          this.generalTaskSrv.getUsersBySupervisor()
            .pipe(takeUntil(this.unsubscribe))
            .subscribe(supervisorAttachedUsers => {
              let supervisorUsers: any = supervisorAttachedUsers;
              let subordinate = supervisorUsers.map(member => member.id);
              this.noteSrv.notesFeeds(subordinate, 1, pageNo)
                .subscribe((userNotes: any) => {
                  this.userNotes = userNotes;
                })
              this.logSrv.logFeeds(subordinate, 1, pageNo)
                .subscribe((activityLogs: any) => {
                  this.activityLogs = activityLogs;
                })
            })
        } else {
          this.noteSrv.notesFeeds(context.data.id, 1, pageNo)
            .subscribe((userNotes: any) => {
              this.userNotes = userNotes;
            })
          this.logSrv.logFeeds(context.data.id, 1, pageNo)
            .subscribe((activityLogs: any) => {
              this.activityLogs = activityLogs;
            })
        }
        break;

      case 'deal':
        this.noteSrv.notesFeeds(context.data.id, 3, pageNo)
          .subscribe((userNotes: any) => {
            this.userNotes = userNotes;
          })
        this.logSrv.logFeeds(context.data.id, 3, pageNo)
          .subscribe((activityLogs: any) => {
            this.activityLogs = activityLogs;
          })
        break;

      case 'company':
        this.noteSrv.notesFeeds(context.company.clientId, 4, pageNo)
          .subscribe((userNotes: any) => {
            this.userNotes = userNotes;
          })
        this.logSrv.logFeeds(context.company.clientId, 4, pageNo)
          .subscribe((activityLogs: any) => {
            this.activityLogs = activityLogs;
          })
        break;

      case 'contact':

        this.noteSrv.notesFeeds(context.contact.clientId, 4, pageNo)
          .subscribe((userNotes: any) => {
            this.userNotes = userNotes;
          })
        this.logSrv.logFeeds(context.contact.clientId, 4, pageNo)
          .subscribe((activityLogs: any) => {
            this.activityLogs = activityLogs;
          })
        break;

      case 'salesPerson':
        this.noteSrv.notesFeeds(context.data.id, 1, pageNo)
          .subscribe((userNotes: any) => {
            this.userNotes = userNotes;
          })
        this.logSrv.logFeeds(context.data.id, 1, pageNo)
          .subscribe((activityLogs: any) => {
            this.activityLogs = activityLogs;
          })
        break;

      case 'teams':
        this.noteSrv.notesFeeds(context.data.id, 2, pageNo)
          .subscribe((userNotes: any) => {
            this.userNotes = userNotes;
          })
        this.logSrv.logFeeds(context.data.id, 2, pageNo)
          .subscribe((activityLogs: any) => {
            this.activityLogs = activityLogs;
          })
        break;
      default:
        break;
    }
  }

  /**
  * Get All Log(s)
  */
  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

}
